export function buildTargetWithReturnPath(
    targetPath: string,
    returnPath: string,
): string {
    if (!targetPath || !returnPath) {
        return targetPath
    }

    const baseOrigin =
        typeof window !== 'undefined' && window.location?.origin
            ? window.location.origin
            : 'http://localhost'

    try {
        const url = new URL(targetPath, baseOrigin)
        url.searchParams.set('returnTo', returnPath)
        return `${url.pathname}${url.search}${url.hash}`
    } catch {
        const separator = targetPath.includes('?') ? '&' : '?'
        return `${targetPath}${separator}returnTo=${encodeURIComponent(returnPath)}`
    }
}
